<template>
  <div>
    <div v-if="categories.length > 0">
      <div
          v-for="category in categories"
          :key="category.id"
      >
        <div
            class="bg-white shadow-sm d-flex justify-content-between align-items-center border mb-2"
            style="border-radius: 10px;"
            :style="{ 'margin-right': level * 50 + 'px'}"
        >
          <div class="mx-3 font-weight-bold">{{ category.title }}</div>
          <div class="d-flex justify-content-between align-items-center">
            <!--UsersModal-->
            <button @click="usersModal(category.id)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
              <i class="fa fa-user text-dark"></i>
            </button>
            <users-category-modal :users="users" :category="category" :modal-number="category.id" />

            <!--CreateModal-->
            <button @click="showModal('create_category_' + category.id)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
              <i class="fa fa-plus text-success"></i>
            </button>
            <create-category-modal :parent_id="category.id" :modal-number="category.id" />

            <!--EditModal-->
            <button @click="showModal('edit_category_' + category.id)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
              <i class="fa fa-edit text-info"></i>
            </button>
            <edit-category-modal
                :modal-number="category.id"
                :category="category"
            />

            <button @click="deleteCategory(category.id)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
              <i class="fa fa-trash text-danger"></i>
            </button>
          </div>
        </div>
        <category-list v-if="category.children && category.children.length > 0" :categories="category.children" :level="level + 1" />
      </div>
    </div>
    <div v-else class="text-center">
      دسته بندی یافت نشد!
    </div>
  </div>
</template>

<script>
import CategoryList from "@/views/ticket/components/category-list.vue";
import CreateCategoryModal from "@/views/ticket/components/create-category-modal.vue";
import $ from "jquery";
import EditCategoryModal from "@/views/ticket/components/edit-category-modal.vue";
import {KTApp} from "@/plugins/core/app";
import {ticketService} from "@/common/api.service";
import toastr from "toastr";
import UsersCategoryModal from "@/views/ticket/components/users-category-modal.vue";
export default {
  name: "category-list",
  components: {UsersCategoryModal, EditCategoryModal, CreateCategoryModal, CategoryList },
  props: {
    categories: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      users: []
    }
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    },
  },
  methods: {
    showModal(id) {
      $('#'+ id).modal('show')
    },
    async usersModal(id) {
      this.users = [];
      await ticketService.getCategoryUser(id)
          .then((response) => {
            this.users = response.data.data
            $('#users_category_' + id).modal('show')
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message)
          })
    },
    deleteCategory(hashid) {
      if (confirm('آیا از حذف این دست بندی مطمئن هستید؟')) {
        let btn = $('#delete-category')

        KTApp.progress(btn)

        ticketService.deleteCategory(hashid)
            .then(async (response) => {
              await this.$store.dispatch('ticket/fetchTicketCategories')
              this.toastr.success(response.data.message)
            })
            .finally(() => {
              KTApp.unprogress(btn)
            })
      }
    }
  }
}
</script>

<style scoped>

</style>